import { useQuery } from "@apollo/client/react";

import { GET_APP_STATE } from "../../graphql/queries";
import { hideSnackBar } from "../../graphql/local-mutations";
import { LocalQuery } from "../../cache";

import {
  Snackbar as Component,
  SnackbarProps,
} from "../../components/atoms/Snackbar";
import okIcon from "../../assets/icons/ok.png";

/**
 * SNACKBAR CONTAINER
 */

export const Snackbar = () => {
  const { data: appData } = useQuery<LocalQuery>(GET_APP_STATE);
  const { isOpen, text } = appData
    ? appData.appState.snackbar
    : { isOpen: false, text: null };

  const props: SnackbarProps = {
    isOpen,
    close: () => hideSnackBar(),
    icon: <img src={okIcon} width="18" height="18" alt={"ok"} />,
    text,
  };

  return <Component {...props} />;
};
